import { render, staticRenderFns } from "./DocButton.vue?vue&type=template&id=275ace75"
import script from "./DocButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DocButton.vue?vue&type=style&index=0&id=275ace75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports